import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwnerKpiComponent } from './owner-kpi.component';
import { Observable } from 'rxjs';
import { Auth, onAuthStateChanged, Unsubscribe } from '@angular/fire/auth';
import { AccessService, PagePermission, AppUser } from '../services/access.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, OwnerKpiComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['../home/home.component.css', './dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private auth = inject(Auth);
  private accessService = inject(AccessService);
  private authUnsubscribe?: Unsubscribe;

  userProfile$?: Observable<AppUser | null | undefined>;
  pagePermissions$?: Observable<PagePermission[]>;

  get greeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning!';
    if (hour < 18) return 'Good Afternoon!';
    return 'Good Evening!';
  }

  getUserDisplayName(profile: AppUser | null | undefined): string {
    if (!profile) return 'there';
    return profile.displayName || (profile as any).name || profile.email?.split('@')[0] || 'there';
  }

  ngOnInit() {
    this.authUnsubscribe = onAuthStateChanged(this.auth, (user) => {
      if (user) {
        this.userProfile$ = this.accessService.getUserProfile(user.uid);
        this.pagePermissions$ = this.accessService.getPagePermissions();
      } else {
        this.userProfile$ = undefined;
        this.pagePermissions$ = undefined;
      }
    });
  }

  ngOnDestroy() {
    if (this.authUnsubscribe) {
      this.authUnsubscribe();
    }
  }

  canAccess(pageId: string, role: string | undefined, permissions: PagePermission[] | null): boolean {
    if (!role || !permissions) return false;
    const normalizedRole = role.toLowerCase().trim();
    if (normalizedRole === 'superadmin') return true; // Super Admin bypass
    const perm = permissions.find(p => p.id === pageId);
    return perm && perm.roles ? perm.roles.some(r => r.toLowerCase().trim() === normalizedRole) : false;
  }
}